import request from '@/utils/request'

let PortApi = {

    /*渠道列表*/
    portList(data) {
        return request._post('/shop/plus.port.port/index', data);
    },

    /* 添加体验者 */
    addTester(data){
        return request._post('/shop/plus.port.port/addtester', data);
    },

    /* 解绑体验者 */
    deleteTester(data){
        return request._post('/shop/plus.port.port/deletetester', data);
    },
    /* 体验者列表 */
    testerList(data){
        return request._post('/shop/plus.port.port/testerlist', data);
    },

    /*端口详情  */
    portDetail(data){
        return request._post('/shop/plus.port.port/portDetail', data);
    },

    /*代码详情  */
    submitCode(data){
        return request._post('/shop/plus.port.port/submitCode', data);
    },

    /* 获取体验码 */
    getQrcode(data){
        return request._post('/shop/plus.port.port/getQrcode', data);
    },

    /*
    *提交审核
    */
    auditCode(data){
        return request._post('/shop/plus.port.port/auditCode', data);
    },


    /* 获取授权url */
    authUrl(data){
        return request._post('/shop/plus.port.port/authUrl', data)
    },

    /* 获取授权url */
    getBaseData(data){
        return request._post('/shop/plus.port.port/getBaseData', data)
    },
    /* 发布代码 */
    releaseCode(data){
        return request._post('/shop/plus.port.port/releaseCode', data)
    },

    /* 查询详情*/
    detail(data){
        return request._get('/shop/plus.port.port/add', data)
    },
    /* 选择界面 */
    select(data){
        return request._get('/shop/plus.port.port/select', data)
    },
    add(data){
        return request._post('/shop/plus.port.port/add', data)
    },
    deletPort(data){
        return request._post('/shop/plus.port.port/deletPort', data)
    },
    /* 体验者列表 */
    versionList(data){
        return request._post('/shop/plus.port.port/versionList', data);
    },
    /* 同步列表 */
    syncCodeTemplate(data){
        return request._post('/shop/plus.port.port/codeTemplateList', data);
    },
    /* 设置隐私指引 */
    setPrivacy(data){
        return request._post('/shop/plus.port.privacy/setPrivacy', data);
    },
    /* 获取隐私指引 */
    getPrivacy(data){
        return request._post('/shop/plus.port.privacy/getPrivacy', data);
    },
     /* 设置小程序APPid */
     setWxappid(data){
        return request._post('/shop/plus.port.privacy/setWxappid', data);
    },
     /* 获取小程序appid */
     getWxappid(data){
        return request._post('/shop/plus.port.privacy/getWxappid', data);
    },
    // 获取已设置的分类
    getcategory(data){
        return request._post('/shop/plus.port.privacy/getcategory', data);
    },
      /* 添加其他渠道端口 */
      addOther(data){
        return request._post('/shop/plus.port.port/portAdd', data)
    },
    /* 查询其他渠道端口详情*/
    detailOther(data){
        return request._get('/shop/plus.port.port/portAdd', data)
    },    
    // 删除除微信小程序，微信公众号外的
    delet(data){
        return request._post('/shop/plus.port.port/delete', data)
    },
}

export default PortApi;



// WEBPACK FOOTER //
// ./src/api/port.js